export default {
      id: "arrow-exit-usage",
      viewBox: "0 0 16 14",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#arrow-exit",
      toString: function () {
        return this.url;
      }
    }